const init = () => {
  const hourMinute = document.querySelector('.js-hour-minutes');

  if (hourMinute) {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.intersectionRatio === 1) {
            initScrollCheck(hourMinute);
          }
        });
      },
      { threshold: 1 },
    );
    observer.observe(hourMinute);
  }
};

const initScrollCheck = hourMinute => {
  if (
    isElementInViewport(hourMinute) &&
    !hourMinute.classList.contains('finished')
  ) {
    const hourMinutes = document.querySelectorAll('.js-hour-minutes');
    for (var i = 0; i < hourMinutes.length; i++) {
      initHourMinuteCounter(hourMinutes[i]);
    }
  }
};

const isElementInViewport = el => {
  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

const initHourMinuteCounter = hourMinute => {
  if (!hourMinute.classList.contains('finished')) {
    hourMinute.classList.add('finished');
    var timeOut = 500;
    setTimeout(function (e) {
      const hour = hourMinute.querySelector('.js-hour');
      const hourMaxNr = hour.dataset.number;
      const minute = hourMinute.querySelector('.js-minute');
      const minuteMaxNr = minute.dataset.number;

      loop(0, hour, hourMaxNr);
      loop(0, minute, minuteMaxNr);
    }, timeOut);
  }
};

const loop = (i, element, max) => {
  const timeOut = 50;
  setTimeout(function () {
    element.innerText = i;
    i++;
    if (i <= max) {
      loop(i, element, max);
    }
  }, timeOut);
};

const hourMinuteCounter = {
  init,
};

export default hourMinuteCounter;
